import MultiSelectModalConfig from "@/ui/composed/modal/MultiSelectModal/MultiSelectModalConfig";
import { FAIconName, TextField } from "@/ui/core";
import { Box } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface MultiSelectModalSearchTextFieldProps extends ViewWithTestID {
  isSearchable?: boolean;
  onChange: (value: string) => void;
  value: string;
}

const MultiSelectModalSearchTextField = ({
  isSearchable,
  onChange,
  testID,
  value,
}: MultiSelectModalSearchTextFieldProps) => {
  if (!isSearchable) {
    return null;
  }

  return (
    <Box>
      <TextField
        accessibilityLabel={MultiSelectModalConfig.SearchPlaceholder}
        autoCapitalize="sentences"
        icon={FAIconName.Search}
        isAutoCorrect={false}
        onChange={onChange}
        placeholder={MultiSelectModalConfig.SearchPlaceholder}
        testID={joinTestIDs(testID, "search")}
        value={value}
      />
    </Box>
  );
};

export default MultiSelectModalSearchTextField;
